<template>
  <v-app style="background-color:#ff9000;margin-top:15px">
    <!-- <div style="padding-top:-10px;background-color:#F8F8F8">
         <p style="text-align:center;padding-top:15px">
            <span @click="home()" class="hvr txt">Home</span> / <span style="color:#EA0202" class="txt">The MD's Desk</span></p>
     </div> -->
     <go-top></go-top>
     <div class="kolkata5 res" >
         <v-layout row wrap >
            <v-flex xs12 sm12 md6 lg12 style="text-align:center">
                 <h1 style="padding:25px;color:whitesmoke;">The MD's Desk</h1>
            </v-flex>
         </v-layout>
     </div>
     <div class="kolkata5 man">
         <v-layout row wrap class="container" style="margin-top:50px">
            <v-flex xs12 sm12 md6 lg12 >
                 <h1 style="padding:15px;color:whitesmoke;">The MD's Desk</h1>
            </v-flex>
         </v-layout>
      </div>
     
<div style="background-color:#ff9000;">
   <v-container >
    <v-card style="border-radius:30px"
    elevation="13" >
     <v-layout row wrap style="padding: 20px;  margin-top: 40px;">
      
        <v-flex xs12 sm12 md6 style=" text-align: center;" >
            
        
            <div class="container" style="padding: 15px;padding-top: 50px;">
                  <img src="../../assets/kowshik-pal.jpeg" class="debashis" />
                <h1 style="font-weight:bold;font-size:35px;margin-top: 30px; color:#ea0202">Kowshik Pal</h1>
                <h4 style="padding-top:30px;font-weight:bold;color:#ff9000" class="txt">
                  Founder and Managing Director
                    <!-- HIDCO West Bengal Housing Infrastructure Development Corporation Ltd, India<br/>
                    Chief Secretary, Govt of West Bengal, IT Department -->
                </h4>


            </div>
           
        </v-flex>
        <v-flex xs12 sm12 md6 style=" " >
            
      
            <div class="container" style="padding: 15px;padding-top: 50px;">

                <p class="txt" style="font-size:22px;padding:15px ; text-align: justify; ">
                  We at Worldwin understand the importance of good education. Each and Every student has 
                  a different set of requirement and we understand that and try our best to provide the 
                  best college as per their needs. We believe that trust is the key to a good relationship
                   and thus we keep complete transparency throughout our process.
                </p>
            </div>
           
        </v-flex>
     
      </v-layout>
    </v-card>
    </v-container>
  </div>


</v-app>
</template>

<script>
//import VueEasyLightbox from 'vue-easy-lightbox';
import GoTop from '@inotom/vue-go-top';
import config from "../../config.json";
export default {
  components: {
    GoTop
  },
  data() {
    return {
      valid: true,
      isLoading: false,
      text: null,
      read: false,
      btnSave: false,
      dialog: false,

      form: {
          name: null,
          email: null,
          subject: null,
          msg: null
      },
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },

      
    };
  },
  
   mounted() {
   },

 methods: {
    home(){
        this.$router.push(`/worldwin`);
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Enquiries`,
            {
              name: this.form.name,
              email: this.form.email,
              subject: this.form.subject,
              msg: this.form.msg
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.dialog = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error("Something went wrong!!");
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    cancel() {
        this.$refs.form.reset();
        this.dialog = false;
    }
 },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200&display=swap');
</style>

<style scoped>
.txt {
  /* font-family: 'Montserrat', sans-serif !important; */
}
.about-us-img {
    background-image: url('https://sasitechnologies.in/csquad/assets/images/bg/bg-2.png');
    background-size: cover;
}
.zero {
    color: #4e97fd;
    font-size: 150px;
}
.covid {
  font-family: 'Quicksand', sans-serif;
  font-weight: bold;
}
.kolkata5 {
    background-image: linear-gradient(to bottom,rgba(187, 35, 35, 0.73), rgba(58, 18, 18, 0.73)), url('http://www.royalacpaints.com/images/about-us-banner.jpg');
    background-size: cover;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.hvr :hover {
    color: #3486D7 !important;
}
.debashis {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-radius: 30px;
    max-width: 50%;
}
</style>
